import styled from 'styled-components'

export const LoginBackground = styled.div`
background-repeat: no-repeat;
 background-image: url('images/backgrounds/background11.jpg');
 background-position: right;
 height:600px
`
export const LoginConteiner = styled.div`
padding: 60px 0;
margin: 0 auto;
max-width: 320px;
font-family: 'Indie Flower', cursive;
font-weight:bold;
`
export const LoginTitle = styled.h1`
text-align: center;
font-family: 'Shadows Into Light', cursive;
font-weight:bold;
`

export const Remainder = styled.div`
color:red;
font-size: 20px;
font-weight:bold;
`